<template>
	<Popup mode="tshirt" :open="true" @closePopup="$emit('closePopup')">
		<template v-if="loaderIsActive">
			<Loader/>
			<p>Hvis du ikke bliver automatisk dirigeret videre, klik <a :href="shopLink" target="_blank">her</a></p>
		</template>
		<template v-else-if="purchaseSuccess">
            <p class="small"><strong>Tak for din bestilling.</strong>Du skulle gerne nu have modtaget en email med bekræftelse på dit køb – ellers er den lige på trapperne. Fortsat godt Hjemmemarked.</p>
		</template>
		<template v-else-if="shopping">
			<p>Vorbasse Marked 2020 T-Shirt</p>
			<img class="img-responsive" src="@/assets/univers/Vorbasse-marked-t-shirt.png" />
			<p class="price">{{price}},00 kr.</p>
            <p class="free-shipping">Gratis fragt</p>
			<ul class="sizes">
				<li @click="selectSize(size)" v-for="size in sizes" :class="{'selected': selectedSize === size}">{{size}}</li>
			</ul>
			<button @click="koebVorbasseTshirt" :class="{'disabled': selectedSize === ''}">
				<template v-if="cart.length === 0">Køb</template>
				<template v-else>Tilføj til bestilling</template>
			</button>
		</template>
		<div class="cart" v-if="cart.length > 0 && !loaderIsActive && !purchaseSuccess" :class="{'pt20': shopping}">
			<div class="inner-cart">
				<p>Din bestilling</p>
				<ul class="items">
					<li v-for="(item,key) in cart"><span class="text">T-shirt str. {{item.toUpperCase()}}</span><span class="price">{{price}},00 kr.</span><span class="remove"><span @click="removeItemFromCart(key)" class="icon">+</span></span></li>
				</ul>
				<p class="total"><strong>Total: </strong> {{cart.length * price}},00 kr.</p>
			</div>
			<div class="row">
				<div class="col">
					<button @click="gaaTilBetalingTshirt" v-if="cart.length > 0" :class="{'disabled': cart.length === 0}">Gå til betaling</button>
				</div>
				<template v-if="!shopping">
					<div class="col">
						<button @click="shopping = true">Tilføj flere</button>
					</div>
				</template>
			</div>
		</div>
	</Popup>
</template>

<script>
	import Popup from "@/components/popup/Popup";
	import {implode} from "@/helperFunctions";
	import Loader from "@/components/Loader";
	const sizesRaw = process.env.VUE_APP_TSHIRT_SIZE_IDS.split(',');
	const sizes = {};
	sizesRaw.forEach((element) => {
		const parts = element.split('=');
		sizes[parts[0]] = parts[1];
	});

	export default {
		components:{Loader, Popup},
		data(){
			return {
				purchaseSuccess:false,
				loaderIsActive:false,
				shopping: true,
				selectedSize: '',
				sizeData: sizes,
				price: 189,
				cart: [],
				shopLink: ''
			}
		},
		computed: {
			sizes(){
				return Object.keys(this.sizeData);
			}
		},
		methods: {
			selectSize(size){
				this.selectedSize = size
			},
			koebVorbasseTshirt(){
				if(this.selectedSize === '') return
				this.cart.push(this.selectedSize)
				this.shopping = false
				this.selectedSize = ''
			},
			gaaTilBetalingTshirt(){
				if(this.cart.length > 0)
				{
					let products = {};
					this.loaderIsActive = true;
					const that = this;
					this.cart.forEach((product) => {
						if(typeof products[this.sizeData[product]] === 'undefined')
							products[this.sizeData[product]] = 0;
						products[this.sizeData[product]]++;
					});
					const windowReference = window.open();
					const key = this.$vorbasseSocket.onCommand('one-time-room-created', (result) =>
					{
						that.$vorbasseSocket.dropCommandListener('one-time-room-created',key);
						if(typeof result.result !== 'undefined' && typeof result.data !== 'undefined' && result.result === 200)
						{
							this.$vorbasseSocket.listen(result.data,(response) => {
								this.$vorbasseSocket.stopListening(result.data);
								if(typeof response === 'object' && typeof response.code !== 'undefined' && response.code === 200)
								{
									that.purchaseSuccess = true;
								}
								else
								{
									that.$store.dispatch('vorbasse/showPrompt',{
										title: 'Køb fejlede',
										prompt: 'Der skete en fejl under købet, prøv igen eller kontakt en medarbejder',
										confirmText: 'Ok - forstået',
										showCancelButton: false
									});
								}
								that.shopLink = '';
								that.loaderIsActive = false;
							});
							that.shopLink = process.env.VUE_APP_SHOP_WOO_CART_ENDPOINT+'?'+implode(products,'=','&')+'&socket_key='+result.data;
							windowReference.target = "width=1000,height=700";
							windowReference.location = that.shopLink;
						}
					});
					this.$vorbasseSocket.emit('create-one-time-room');
				}
			},
			removeItemFromCart(key){
				this.cart.splice(key, 1);
				if(this.cart.length === 0){
					this.shopping = true
					this.selectedSize = ''
				}
			},
		}
	};
</script>

<style lang="scss" scoped>
	.cart{
		text-align: left;
		&.pt20{
			padding-top: 20px;
		}
		.inner-cart{
			padding: 0px 7px 5px;
		}
		p{
			max-width: 100% !important;
			&.total{
				margin-bottom: 15px !important;
			}
		}
		button{
			text-transform: none !important;
		}
		ul.items{
			margin: 0px 0px 10px;
			padding: 0px;
			li{
				display: table;
				width: 100%;
				list-style: none;
				margin: 0px;
				padding: 8px 0px;
				border-bottom: 1px dashed $white;
				color: $white;
				.text,.price,.remove{
					display: table-cell;
					vertical-align: middle;
				}
				.price{
					width: 90px;
				}
				.remove{
					width: 20px;
					.icon{
						display: block;
						width: 20px;
						height: 20px;
						font-size: 20px;
						text-align: center;
						line-height: 20px;
						transform: rotate(45deg);
						background: $white;
						color: $green;
						border-radius: 50%;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>
